import { render, staticRenderFns } from "./StaticDetail.vue?vue&type=template&id=69a4f4a0"
import script from "./StaticDetail.vue?vue&type=script&lang=js"
export * from "./StaticDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports